<script lang="ts">
  import Modal from "$components/+blocks/Modal/Modal.svelte";
  import ForumSwitcher from "$components/forum/ForumSwitcher.svelte";
  import { thread as threadStore } from "$stores/thread";
  import CreateUpdateThreadForm from "./CreateUpdateThreadForm.svelte";
  import { forum } from "$stores/forum";
  import { communitySlug } from "$stores/community";
  import LoadingAtom from "$components/+blocks/Loading/LoadingAtom.svelte";
  import api from "api";
  import cx from "classnames";
  import type { Thread } from "models/forums";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import type { ForumSpace } from "@outverse-video/outverse-api-client-lib";
  import { Cross, Eye, EyeSlash } from "$components/+blocks/OVIcon";
  import type { User } from "$stores/user";

  export let open: boolean;
  export let thread: Thread | undefined;
  export let user: User;

  let fullScreen = false;
  let forumSpace: ForumSpace | undefined;

  const getDefaultForumSpace = async () => {
    if ($forum.forumSpace.uuid) {
      forumSpace = $forum.forumSpace;
      return;
    }
    // set forum to last one with last thread user created,
    // probably should replace this with a specialised backend route
    const resp = await api.searchThreadsList({
      author: user?.uuid,
      communitySlug: $communitySlug,
    });
    const latestThread = resp.data?.results?.[0];
    if (latestThread) {
      forumSpace = latestThread.forumSpace as ForumSpace;
      return;
    }
    forumSpace = {
      title: "Select a forum",
      uuid: "",
      color: "#A1A3A7",
    } as ForumSpace;
  };
</script>

<Modal
  bind:open
  withCloseIcon={false}
  {fullScreen}
  disallowClickOutside
  maxWidth="max-w-[884px]"
  maxHeight="max-h-[550px]"
>
  <div class={cx("size-full", fullScreen ? "pt-6" : "pt-3")}>
    <div class="mx-auto flex size-full flex-col">
      <div class="mb-3 flex items-center px-3">
        <div class="flex items-center gap-1.5">
          {#await getDefaultForumSpace()}
            <LoadingAtom size="h-7 w-20" />
          {:then}
            <ForumSwitcher
              selectedForumSpace={forumSpace}
              on:select={(ev) => (forumSpace = ev.detail)}
            />
          {/await}
          <span class="font-medium text-neutral-400 dark:text-neutral-400">/</span>
          <span class="text-sm font-medium text-neutral-400 dark:text-neutral-400">
            {thread ? "Update" : "Create"} thread
          </span>
        </div>

        <div class="ml-auto flex shrink-0 gap-1 text-neutral-400">
          <!-- Fullscreen button -->
          <IconButton
            variant="tertiary"
            icon={fullScreen ? EyeSlash : Eye}
            a11yLabel="Toggle focus mode"
            on:click={() => (fullScreen = !fullScreen)}
            customIconSize="h-5"
          />

          <!-- Close button -->
          {#if !fullScreen}
            <IconButton
              variant="tertiary"
              icon={Cross}
              a11yLabel="Close"
              on:click={() => threadStore.closeThreadModal()}
              customIconSize="h-5"
            />
          {/if}
        </div>
      </div>

      <CreateUpdateThreadForm {user} on:updateThread on:createThread {forumSpace} {thread} />
    </div>
  </div>
</Modal>
